import { useEffect, useState } from "react";

type Step = { title?: string };
type Props = {
  steps: Step[];      // [{ title: 'Код' }, { title: 'Часовой пояс' }, { title: 'Установка' }]
  current: number;    // 1..steps.length (у нас 3)
};

export default function Stepper({ steps, current }: Props) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => { setMounted(true); }, []);

  return (
    <div className="w-full max-w-3xl mx-auto">
      <div className="flex items-center justify-between">
        {steps.map((s, i) => {
          const index = i + 1;
          const isDone = index < current;
          const isActive = index === current;

          // задержка для последовательной анимации соединительных линий
          const delayMs = i * 150;

          return (
            <div key={i} className="flex-1 flex items-center">
              {/* Узел шага */}
              <div className="flex flex-col items-center min-w-[64px]">
                <div
                  className={[
                    "flex items-center justify-center w-9 h-9 rounded-full border-2 transition-all duration-300",
                    isDone
                      ? "bg-black text-white border-black scale-100"
                      : isActive
                      ? "border-black text-black scale-100"
                      : "border-gray-300 text-gray-400 scale-95",
                  ].join(" ")}
                  aria-current={isActive ? "step" : undefined}
                >
                  {isDone ? "✓" : index}
                </div>
                {s.title && (
                  <div
                    className={[
                      "mt-2 text-xs whitespace-nowrap transition-colors",
                      isActive ? "text-black font-medium" : "text-gray-500",
                    ].join(" ")}
                >
                    {s.title}
                  </div>
                )}
              </div>

              {/* Соединительная линия (кроме последней точки) */}
              {index < steps.length && (
                <div className="mx-2 h-[2px] flex-1 rounded bg-gray-200 overflow-hidden">
                  {/* Внутренняя «заполняющаяся» полоса */}
                  <div
                    className={[
                      "h-full bg-black origin-left transition-transform duration-700",
                      // скейлим из 0 в 1; если шаг пройден — показываем 1
                      (mounted && index < current) ? "scale-x-100" : "scale-x-0",
                    ].join(" ")}
                    style={{ transitionDelay: `${delayMs}ms` }}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
      <div className="mt-3 h-px bg-gray-100" />
    </div>
  );
}
